export default __webpack_public_path__ + "static/rust-ca7d5bec14c9cab2e13cd4c79224a781.webp";